<template>
  <div style="background: #F2F6FC;">
    <MyBanner />
    <div>
      <div class="w1200">
        <div class="title">
          <div class="AnnouncementDetails">
            <el-breadcrumb :separator-icon="ArrowRight">
              <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item @click="goPlatformDynamics()">
                <span class="title-name">{{Factive}}</span>
              </el-breadcrumb-item>
              <!-- <el-breadcrumb-item>{{Type(mesageData.type)}}</el-breadcrumb-item> -->
              <el-breadcrumb-item>内容详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- <div class="join" @click="joinLogin">我要参加</div> -->
        </div>
        <div class="content">
          <div class="content-tip">
            <div class="bt">{{mesageData.name}}</div>
            <div class="announcement-flex">
              <div class="flex">
                <div class="title-box">项目类别：</div>
                <div class="content-box">{{TypeX(mesageData.tradeClassification)}}</div>
              </div>
              <!-- <div class="flex">
                <div class="title-box">报价截止时间：</div>
                <div class="content-box">{{mesageData.endTime}}</div>
              </div> -->
              <div class="flex">
                <div class="title-box">发布时间：</div>
                <div class="content-box">{{mesageData.publishTime}}</div>
                <div class="title-box" style="margin-left:20px;">查看次数：</div>
                <div class="content-box">{{1+Number(mesageData.viewNum)||1}}</div>
              </div>
            </div>
          </div>
          <!-- <div style="font-size: 14px;color: rgb(10, 96, 234);text-align: left;margin-top: 20px;margin-bottom: 10px;">
            详情介绍：</div> -->
          <div class="content-message" v-html="mesageData.content" v-if="mesageData.content != ''"></div>
          <div class="content-message" style="text-align: center;line-height: 100px;color: gray;" v-else>暂无详情</div>
          <template v-if="mesageData.files">
            <span style="font-size: 20px;">附件：</span>
            <div class="download-box" v-for="item in fileList" @click="downloadFile(item)">
              <img src="../static/px-downlode.png" style="vertical-align: top;">
              <span style="font-size:24px;margin-left: 20px;cursor: pointer;">{{item.fileName}}</span>
            </div>
          </template>
        </div>
      </div>
      <MyFooter />
    </div>
  </div>
</template>
<script setup>
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { getNoticeById, loginTree } from '@/api/index.js'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
let router = useRouter()
let mesageData = ref({})
let loginTreeArr = ref('')
let Factive = ref('')
let fileList = ref([])

let Type = (value) => {
  if (value == 'tender_bulletin') {
    return '招标公告'
  } else if (value == 'correctional_bulletin') {
    return '变更公告'
  } else if (value == 'win_candidate_publicity') {
    return '中标候选人公示'
  } else if (value == 'win_notice') {
    return '中标结果公告'
  } else if (value == 'failed_notice') {
    return '其他公告'
  }
}
let TypeX = (value) => {
  if (value == "A") {
    return '工程'
  } else if (value == "B") {
    return '货物'
  } else if (value == "C") {
    return '服务'
  }
}
let detailData = async () => {
  await getNoticeById({ id: router.currentRoute.value.query.ids }).then(res => {
    mesageData.value = res.data
    if(mesageData.value.files){
      fileList.value = JSON.parse(mesageData.value.files)
    }
  })
}

let goPlatformDynamics = () => {
  console.log(Factive.value);
  if (Factive.value == '工程公告') {
    router.push({ path: '/bulletinII', query: { title: Factive.value, type: "A" } })
  } else if (Factive.value == '货物公告') {
    router.push({ path: '/bulletinII', query: { title: Factive.value, type: "B" } })
  } else if (Factive.value == '服务公告') {
    router.push({ path: '/bulletinII', query: { title: Factive.value, type: "C" } })
  } else {
    router.push({ path: '/platformDynamics', query: { title: Factive.value } })

  }
}
let joinLogin = () => {
  loginTreeArr.value.forEach(item => {
    if (item.dictValue == '集团用户登录入口') {
      window.open(item.dictKey, '_blank')
    }
  })
}
let downloadFile = (item) =>{
  window.open(item.fileUrl)
}

onMounted(async () => {
  Factive.value = router.currentRoute.value.query.title ? router.currentRoute.value.query.title : '平台公告'

  detailData()
  await loginTree().then(res => {
    loginTreeArr.value = res.data
  })
})
</script>
<style scoped>
::v-deep .el-tabs__item {
  font-size: 18px;
  color: rgba(0, 117, 194, 1);
}
::v-deep .el-tabs__active-bar {
  background-color: rgba(0, 117, 194, 1);
}
::v-deep .el-table th.el-table__cell {
  background: rgba(243, 245, 247, 1);
  font-size: 14px;
  font-weight: 400;
  color: rgb(79, 84, 112);
}
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.content-message {
  min-height: 100px;
  border-radius: 5px;
  /* background: rgb(255, 255, 255); */
  /* border: 1px solid rgb(215, 215, 215); */
  color: #344;
  padding: 0 20px;
  box-sizing: border-box;
  line-height: 1.8;
  font-size: 16px;
}
.bt {
  font-size: 32px;
  font-weight: 600;
  color: #444;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e0e0;
  text-align: center;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0 15px 0;
}
.AnnouncementDetails {
  font-size: 22px;
  color: rgb(0, 0, 0);
  display: flex;
  align-items: flex-end;
}
.join {
  width: 100px;
  height: 36px;
  border-radius: 4px;
  background: linear-gradient(
      180deg,
      rgba(0, 102, 166, 1) 0%,
      rgba(59, 133, 243, 1) 100%
    ),
    rgba(204, 204, 204, 1);
  font-size: 16px;
  font-weight: 500;
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: 36px;
  margin-right: 20px;
  cursor: pointer;
}
.line1 {
  width: 4px;
  height: 28px;
  background: rgb(10, 96, 234);
  margin-right: 5px;
}
.line2 {
  width: 4px;
  height: 18px;
  background: rgb(10, 96, 234);
  margin-right: 5px;
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  margin-bottom: 20px;
}
.content-tip {
  border-radius: 5px;
  padding: 20px;
  /* background: rgba(243, 245, 247, 1); */
}
.title-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}
.content-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}
.flex {
  display: flex;
  align-items: center;
  margin-right: 12px;
}
.announcement-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.title-name:hover {
  color: #409eff;
}
.title-name {
  color: #303133;
  font-weight: 600;
  cursor: pointer;
}
.download-box {
  width: 90%;
  margin: 20px auto;
  height: 50px;
}
</style>